<template>
  <div class="photo-overlay" v-if="isActive">
    <!-- 全屏相机背景 -->
    <div class="camera-background">
      <video ref="backgroundVideo" autoplay playsinline muted></video>
    </div>

    <!-- 半透明遮罩层（只在拍照框外） -->
    <div class="outer-mask">
      <!-- 上遮罩 -->
      <div class="mask-top"></div>
      <!-- 下遮罩 -->
      <div class="mask-bottom"></div>
      <!-- 左遮罩 -->
      <div class="mask-left"></div>
      <!-- 右遮罩 -->
      <div class="mask-right"></div>
    </div>

    <div class="header-center">扫一扫</div>
    <div class="close-button" @click="closePhoto">×</div>

    <div class="photo-container">
      <div class="photo-box" :class="{ 'focusing': isFocusing }">
        <video
          ref="photoVideo"
          autoplay
          playsinline
          class="photo-video"
        ></video>

        <div class="overlay-ui">
          <!-- 扫描线动画 -->
          <div class="scan-line"></div>
          <!-- 四个角 -->
          <div class="corner top-left"></div>
          <div class="corner top-right"></div>
          <div class="corner bottom-left"></div>
          <div class="corner bottom-right"></div>
          <!-- 中心聚焦点 -->
          <div class="focus-point"></div>
        </div>
      </div>

      <!-- 手电筒图标和文字（可点击） -->
      <div class="flashlight-display" @click="takePhoto" :class="{ 'disabled': isTaking }">
        <svg class="flashlight-icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="40" height="40">
          <path d="M747.52 138.24l4.4288 1.2032c5.91872 1.65888 9.76384 2.95424 11.5456 3.8912C804.44416 164.8128 819.2 188.61568 819.2 214.66112v136.4736c0 5.64224-0.57344 11.14112-1.664 16.4352-1.8432 15.6416-9.2928 30.04416-20.93568 40.07936l-106.94656 92.1856-0.74752 0.42496-23.30624 20.1216v283.83744c0 42.20416-32.09216 76.42112-71.68 76.42112H424.96c-39.58784 0-71.68-34.21696-71.68-76.42112l-0.00512-282.53696L248.94464 431.616a23.99232 23.99232 0 0 1-3.88608-4.2752l-22.81472-19.6864c-12.08832-10.43456-19.18464-25.0112-20.9408-40.26368A81.53088 81.53088 0 0 1 199.68 351.1296V214.66112C199.68 172.45696 231.77216 138.24 271.36 138.24h476.16z m-7.2192 61.44H271.36c-8.18176 0-14.86848 6.84544-15.3344 15.47264L256 216.1152v136.98048c0 1.23904 0.11776 2.41664 0.34816 3.54304 0.3584 1.792 0.65024 3.6096 0.86016 5.4272 0.03072 0.3072 0.10752 0.512 0.27136 0.71168l0.19456 0.19456 22.81472 19.75808c1.77152 1.536 3.456 3.17952 5.03808 4.93056l1.2544 1.44384 101.9392 88.34048c12.7488 11.04896 20.33664 27.47392 20.84864 44.95872l0.0256 1.87904 0.00512 283.5968c0 8.7552 6.39488 15.90784 14.45888 16.4096L424.96 824.32h168.96c8.18176 0 14.86848-6.84544 15.3344-15.47264l0.0256-0.96768v-284.89728c0-17.5616 7.15264-34.21184 19.5328-45.63968l1.34656-1.2032 23.30624-20.1984c1.11616-0.96768 2.26816-1.88928 3.45088-2.7648L761.1904 362.9568a1.39776 1.39776 0 0 0 0.4608-0.89088c0.21504-1.80224 0.50176-3.59424 0.8704-5.376 0.1536-0.75776 0.256-1.54624 0.31232-2.3552l0.04096-1.23392V216.4736l-0.37888-0.52224c-2.8672-3.88096-8.97024-8.94976-18.9952-14.67904l-2.42688-1.3568-0.77824-0.23552zM509.44 481.28a33.28 33.28 0 0 1 33.28 33.28v92.16a33.28 33.28 0 1 1-66.56 0v-92.16a33.28 33.28 0 0 1 33.28-33.28z" fill="currentColor"/>
        </svg>
        <span class="flashlight-text">{{ isTaking ? '拍照中...' : '拍照' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { uploadPhoto } from '@/api/index';

export default {
  name: 'PicPx',
  props: {
    value: {
      type: Boolean,
      default: undefined, // 使用 undefined 来区分是否传入了 prop
    },
    keyScrent: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isActive: false,
      backgroundStream: null,
      photoStream: null,
      camera: 'rear',
      isTaking: false,
      isFocusing: false,
      isRoutePage: false, // 标记是否为路由页面
    };
  },
  watch: {
    value(newVal) {
      // 只有当 value prop 被传入时才响应变化（弹窗模式）
      if (this.value !== undefined) {
        this.isActive = newVal;
        if (newVal) {
          this.checkAndInit();
        } else {
          this.cleanup();
        }
      }
    },
  },
  computed: {
    streamConstraints() {
      return {
        video: {
          facingMode: this.camera === 'rear' ? 'environment' : 'user',
          width: { ideal: 1280, max: 1920 },
          height: { ideal: 720, max: 1080 },
          frameRate: { ideal: 30, max: 30 },
        },
      };
    },
  },
  methods: {
    /**
     * 检查并初始化相机
     */
    checkAndInit() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        Toast.fail('当前浏览器不支持摄像头访问，请更换浏览器或升级系统');
        if (this.isRoutePage) {
          // 如果是路由页面，返回上一页
          this.$router.go(-1);
        } else {
          this.$emit('input', false);
        }
        return;
      }
      this.initCamera();
    },

    /**
     * 初始化相机
     */
    async initCamera() {
      try {
        this.stopCamera();

        let stream;
        try {
          stream = await navigator.mediaDevices.getUserMedia({
            video: {
              facingMode: this.camera === 'rear' ? 'environment' : 'user',
              width: { ideal: 1280, max: 1920 },
              height: { ideal: 720, max: 1080 },
              frameRate: { ideal: 30, max: 30 },
            },
          });
        } catch (error) {
          if (error.name === 'OverconstrainedError') {
            stream = await navigator.mediaDevices.getUserMedia({
              video: {
                facingMode: this.camera === 'rear' ? 'environment' : 'user',
              },
            });
          } else {
            throw error;
          }
        }

        this.backgroundStream = stream;
        this.photoStream = stream;

        if (this.$refs.backgroundVideo) {
          this.$refs.backgroundVideo.srcObject = stream;
        }

        if (this.$refs.photoVideo) {
          this.$refs.photoVideo.srcObject = stream;
        }
      } catch (error) {
        this.handleCameraError(error);
      }
    },

    /**
     * 拍照
     */
    async takePhoto() {
      if (this.isTaking || !this.photoStream) {
        return;
      }

      this.isTaking = true;

      try {
        // 聚焦动画效果
        this.isFocusing = true;
        setTimeout(() => {
          this.isFocusing = false;
        }, 300);

        // 从video元素捕获图片
        const video = this.$refs.photoVideo;
        if (!video || !video.videoWidth) {
          Toast.fail('相机未就绪，请稍候再试');
          this.isTaking = false;
          return;
        }

        // 创建canvas并绘制视频帧
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // 设置canvas尺寸为拍照框的大小（300x300）
        canvas.width = 300;
        canvas.height = 300;

        // 计算视频的实际尺寸和拍照框的映射关系
        const videoAspect = video.videoWidth / video.videoHeight;
        const boxAspect = 300 / 300;

        let sx; let sy; let sw; let
          sh;
        if (videoAspect > boxAspect) {
          // 视频更宽，按高度适配
          sh = video.videoHeight;
          sw = video.videoHeight * boxAspect;
          sx = (video.videoWidth - sw) / 2;
          sy = 0;
        } else {
          // 视频更高，按宽度适配
          sw = video.videoWidth;
          sh = video.videoWidth / boxAspect;
          sx = 0;
          sy = (video.videoHeight - sh) / 2;
        }

        // 绘制视频帧到canvas（只截取拍照框对应的区域）
        ctx.drawImage(video, sx, sy, sw, sh, 0, 0, 300, 300);

        // 转换为blob
        canvas.toBlob(async (blob) => {
          if (!blob) {
            Toast.fail('拍照失败，请重试');
            this.isTaking = false;
            return;
          }

          // 创建FormData并上传
          const formData = new FormData();
          formData.append('photo', blob, `photo_${Date.now()}.jpg`);

          try {
            Toast.loading('正在签到，请稍后...');
            debugger;
            const res = await uploadPhoto(formData, this.keyScrent);
            if (res.code === 200) {
              this.$emit('photo-success', res.data);
            } else {
              Toast.fail(res.msg);
            }
            // Toast.success('拍照上传成功');

            this.closePhoto();
          } catch (error) {
            console.error('上传失败:', error);
            Toast.fail('上传失败，请重试');
          } finally {
            this.isTaking = false;
          }
        }, 'image/jpeg', 0.9);
      } catch (error) {
        console.error('拍照失败:', error);
        Toast.fail('拍照失败，请重试');
        this.isTaking = false;
      }
    },

    /**
     * 停止相机
     */
    stopCamera() {
      if (this.backgroundStream) {
        try {
          this.backgroundStream.getTracks().forEach((track) => {
            try {
              track.stop();
            } catch (e) {
              console.warn('Error stopping track:', e);
            }
          });
        } catch (e) {
          console.warn('Error stopping stream:', e);
        }
        this.backgroundStream = null;
      }

      this.photoStream = null;

      if (this.$refs.backgroundVideo) {
        this.$refs.backgroundVideo.srcObject = null;
      }

      if (this.$refs.photoVideo) {
        this.$refs.photoVideo.srcObject = null;
      }
    },

    /**
     * 清理资源
     */
    cleanup() {
      this.stopCamera();
    },

    /**
     * 关闭拍照器
     */
    closePhoto() {
      this.cleanup();
      if (this.isRoutePage) {
        // 如果是路由页面，返回上一页
        this.$router.go(-1);
      } else {
        // 如果是弹窗模式，发送事件
        this.$emit('input', false);
      }
    },

    /**
     * 处理相机错误
     */
    handleCameraError(error) {
      const errorName = error.name || 'UnknownError';
      const errorMessages = {
        NotAllowedError: '请允许摄像头访问权限',
        NotFoundError: '该设备无摄像头',
        NotSupportedError: '当前浏览器不支持摄像头访问，请更换浏览器或升级系统',
        StreamApiNotSupportedError: '当前浏览器不支持摄像头访问，请更换浏览器或升级系统',
        OverconstrainedError: '当前设备摄像头分辨率不兼容',
        NotReadableError: '相机可能被占用，请尝试重启应用或设备',
      };

      const message = errorMessages[errorName] || '相机初始化失败，请重试';
      Toast.fail(message);
      if (this.isRoutePage) {
        this.$router.go(-1);
      } else {
        this.$emit('input', false);
      }
    },

    /**
     * 键盘事件处理
     */
    handleKeydown(e) {
      if (e.key === 'Escape' && this.isActive) {
        this.closePhoto();
      } else if (e.key === 'Enter' && this.isActive && !this.isTaking) {
        this.takePhoto();
      }
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);

    // 判断是否为路由页面（没有传入 value prop）
    if (this.value === undefined) {
      this.isRoutePage = true;
      this.isActive = true;
      this.checkAndInit();
    } else {
      // 弹窗模式，使用 value 的值
      this.isActive = this.value;
      if (this.value) {
        this.checkAndInit();
      }
    }
  },

  beforeDestroy() {
    this.cleanup();
    document.removeEventListener('keydown', this.handleKeydown);
  },
};
</script>

<style scoped>
.photo-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  overflow: hidden;
}

/* 全屏相机背景 */
.camera-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;
  background: radial-gradient(circle at top, #1f2933 0%, #020617 60%, #000 100%);
}

.camera-background video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scale(1.1);
}

/* 半透明遮罩层容器 */
.outer-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

/* 扫描框位置：300x300px，居中，距离顶部20vh */
/* 上遮罩 */
.mask-top {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 20vh;
  background-color: rgba(0, 0, 0, 0.5);
  pointer-events: auto;
}

/* 下遮罩 */
.mask-bottom {
  position: absolute;
  top: calc(20vh + 300px);
  left: 0;
  width: 100%;
  height: calc(100vh - 20vh - 300px);
  background-color: rgba(0, 0, 0, 0.5);
  pointer-events: auto;
}

/* 左遮罩 */
.mask-left {
  position: absolute;
  top: 20vh;
  left: 0;
  width: calc(50% - 150px);
  height: 300px;
  background-color: rgba(0, 0, 0, 0.5);
  pointer-events: auto;
}

/* 右遮罩 */
.mask-right {
  position: absolute;
  top: 20vh;
  right: 0;
  width: calc(50% - 150px);
  height: 300px;
  background-color: rgba(0, 0, 0, 0.5);
  pointer-events: auto;
}

.close-button {
  position: absolute;
  top: 40px;
  right: 30px;
  color: white;
  font-size: 40px;
  line-height: 1;
  cursor: pointer;
  font-weight: 300;
  z-index: 1002;
  text-shadow: 0 0 5px rgba(0,0,0,0.5);
  transition: transform 0.2s;
}

.close-button:active {
  transform: scale(0.9);
}

.header-center {
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 17px;
  font-weight: bold;
  text-align: center;
  z-index: 1002;
  text-shadow: 0 0 5px rgba(0,0,0,0.5);
}

.photo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.photo-box {
  position: relative;
  width: 300px;
  height: 300px;
  margin-top: 20vh;
  border-radius: 8px;
  overflow: hidden;
  z-index: 3;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  animation: borderPulse 2s ease-in-out infinite;
}

/* 拍照框呼吸动画 */
@keyframes borderPulse {
  0%, 100% {
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3),
                0 0 10px rgba(255, 255, 255, 0.1);
  }
  50% {
    box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5),
                0 0 20px rgba(255, 255, 255, 0.3);
  }
}

/* 聚焦时的缩放效果 */
.photo-box.focusing {
  transform: scale(0.95);
  box-shadow: 0 0 0 4px rgba(255, 215, 0, 0.6),
              0 0 30px rgba(255, 215, 0, 0.4);
  animation: none;
}

.photo-video {
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.overlay-ui {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
}

.corner {
  position: absolute;
  width: 25px;
  height: 25px;
  border-style: solid;
  border-color: #fff;
  z-index: 3;
}

.corner.top-left {
  top: -2px;
  left: -2px;
  border-width: 4px 0 0 4px;
}

.corner.top-right {
  top: -2px;
  right: -2px;
  border-width: 4px 4px 0 0;
}

.corner.bottom-left {
  bottom: -2px;
  left: -2px;
  border-width: 0 0 4px 4px;
}

.corner.bottom-right {
  bottom: -2px;
  right: -2px;
  border-width: 0 4px 4px 0;
}

/* 扫描线动画 */
.scan-line {
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(to right, transparent, #ffc107, transparent);
  box-shadow: 0 0 10px #ffc107;
  animation: scan-animation 2.5s linear infinite;
  z-index: 3;
}

@keyframes scan-animation {
  0% { top: 0; }
  50% { top: calc(100% - 2px); }
  100% { top: 0; }
}

/* 中心聚焦点 */
.focus-point {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  border: 2px solid rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  z-index: 3;
  animation: focusPulse 2s ease-in-out infinite;
}

@keyframes focusPulse {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.6;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0.9;
  }
}

/* 手电筒显示（可点击） */
.flashlight-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
  color: #fff;
  z-index: 1002;
  cursor: pointer;
  transition: transform 0.2s, opacity 0.2s;
}

.flashlight-display:active:not(.disabled) {
  transform: scale(0.9);
}

.flashlight-display.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.flashlight-icon {
  color: #fff;
  margin-bottom: 8px;
  filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.5));
  transition: filter 0.3s;
}

.flashlight-display:not(.disabled):hover .flashlight-icon {
  filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.8));
}

.flashlight-text {
  font-size: 14px;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}
</style>
